var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHeartGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80711 5.94426C0.676599 4.77282 0.675303 2.89377 1.80711 1.72326C2.373 1.138 3.11705 0.844971 3.86211 0.844971C4.60716 0.844971 5.35495 1.138 5.92086 1.72326L6.59961 2.42738L7.27836 1.72697C8.41017 0.556418 10.2603 0.556444 11.3921 1.72697C12.5239 2.8975 12.5239 4.77744 11.3921 5.94797C10.6257 6.74065 9.85938 7.53377 9.0931 8.32689C8.31949 9.1276 7.54589 9.92831 6.77211 10.7286C6.72677 10.7759 6.66371 10.8028 6.59773 10.8028C6.53176 10.8028 6.4687 10.7759 6.42336 10.7286L1.80711 5.94426Z",
    fill: "#7EC34D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_487_8400",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80711 5.94426C0.676599 4.77282 0.675303 2.89377 1.80711 1.72326C2.373 1.138 3.11705 0.844971 3.86211 0.844971C4.60716 0.844971 5.35495 1.138 5.92086 1.72326L6.59961 2.42738L7.27836 1.72697C8.41017 0.556418 10.2603 0.556444 11.3921 1.72697C12.5239 2.8975 12.5239 4.77744 11.3921 5.94797C10.6257 6.74065 9.85938 7.53377 9.0931 8.32689C8.31949 9.1276 7.54589 9.92831 6.77211 10.7286C6.72677 10.7759 6.66371 10.8028 6.59773 10.8028C6.53176 10.8028 6.4687 10.7759 6.42336 10.7286L1.80711 5.94426Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_487_8400)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeartGreen);
export default __webpack_public_path__ + "static/media/icHeartGreen.f9410c7eb856e4a57b93dc22a978fc1a.svg";
export { ForwardRef as ReactComponent };